module.exports = function() {
  return new Worker(__webpack_public_path__ + "assets/supervision.worker.f7a18ce06681bbd47ae8.js");
};